module.exports = __webpack_public_path__ + "static/media/Avatars_Other-28.29af8146.png";